import React from 'react';

import FilePreviewPlugin from './FilePreviewPlugin';

export default {
  FilePreviewPlugin: <FilePreviewPlugin />,
};
